import { React, useState, useEffect } from "react";
import { Responsive, WidthProvider } from "react-grid-layout";
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";
import "./grid.css";
import GraphErrorPage from "../error/graph-error/graphError";
import ViewCharts from "../view-charts/viewCharts";
import EditCharts from "../edit-charts/editCharts";

const ResponsiveReactGridLayout = WidthProvider(Responsive);
const Grid = ({
  setGridItems,
  gridItems,
  onLayoutChange,
  chartDataModelObjects,
  setchartDataModelObjects,
  isEdit,
  machineValues,
  propertyValues,
  isDataLoadingByDate,
  setIsDataLoadingByDate
}) => {

  const noDashboardsMessage = "No Dashboards Found";
  const [compactType] = useState("vertical");
  const gridHeight = isEdit ? 100 : 70;
  useEffect(() => {
  }, [gridItems]);

  return (
    <div className="grid-container">
      <ResponsiveReactGridLayout
        className="layout"
        layout={gridItems}
        onLayoutChange={onLayoutChange}
        rowHeight={gridHeight}
        cols = {{ lg: 12, md: 12, sm: 6, xs: 4, xxs: 2 }}
        isDraggable={isEdit}
        isResizable={isEdit}
        measureBeforeMount={false}
        useCSSTransforms={true}
        compactType={compactType}
        preventCollision={!compactType}
      >
        {gridItems.map((item) => (
          <div key={item.key} data-grid={item} className="grid-item">
            {isEdit ? (
              <EditCharts
                key={item.key}
                setGridItems={setGridItems}
                gridItems={gridItems}
                gridKey={item.key}
                chartDataModelObjects={chartDataModelObjects}
                setchartDataModelObjects={setchartDataModelObjects}
                machineValues={machineValues}
                propertyValues={propertyValues}
                isDataLoadingByDate={isDataLoadingByDate}
                setIsDataLoadingByDate={setIsDataLoadingByDate}
              />
            ) : 
            (chartDataModelObjects.length > 0 ?
              <ViewCharts
                key={item.key}
                machineValues={machineValues}
                propertyValues={propertyValues}
                gridKey={item.key}
                chartDataModelObjects={chartDataModelObjects}
                isDataLoadingByDate={isDataLoadingByDate}
                setIsDataLoadingByDate={setIsDataLoadingByDate}
              />
          : <GraphErrorPage errorMessage={noDashboardsMessage}></GraphErrorPage>
            )}
          </div>
        ))}
      </ResponsiveReactGridLayout>
    </div>
  );
};

export default Grid;
